import script from "./BulkActionsOperationValueControl.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkActionsOperationValueControl.vue?vue&type=script&setup=true&lang=js"

import "./BulkActionsOperationValueControl.vue?vue&type=style&index=0&id=1a7a7a54&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a7a7a54"]])

export default __exports__